import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { onlyUpdateForKeys } from 'recompose';
import { propBool, propFunc, propNumber, propStr, } from '../../../helpers/custom-prop-types';
import { validateMiddleTaskOther } from '../../../validate/profile';
import PlainInputField from '../Common/Fields/PlainInputField';
import InputErrorWithConnect from '../Common/InputErrorWithConnect';
import { Checkbox } from '../FormFields';
const CategoryMiddleSingleFieldsAndLabel = (props) => {
    const { disabled, isEtcCheck, middleId, middleIsOther, middleName, name, otherMiddleClassName, otherName, wrapMiddleClassName, wrapOnChange, } = props;
    if (!middleIsOther) {
        return (_jsx("div", Object.assign({ className: wrapMiddleClassName }, { children: _jsx(Checkbox, { disabled: disabled, name: name, option: { label: middleName, value: middleId }, wrapOnChange: (e) => {
                    wrapOnChange(e, middleId);
                } }) })));
    }
    return (_jsxs("div", Object.assign({ className: 'is-other is-display-block' }, { children: [_jsxs("div", Object.assign({ className: `${wrapMiddleClassName} pr0 is-display-flex alignItemCenter is-nowrap mt05 sp-mt0 sp-flex-direction-column sp-flex-align-start` }, { children: [_jsx(Checkbox, { disabled: disabled, name: name, option: { label: middleName, value: middleId }, wrapOnChange: (e) => {
                            wrapOnChange(e, middleId);
                        } }), _jsx(PlainInputField, { className: `input-form-text asign-state is-after-select ${otherMiddleClassName} mt0`, disabled: !isEtcCheck, name: otherName, placeholder: 'その他', showError: false, validate: isEtcCheck ? validateMiddleTaskOther : [] })] })), _jsx(InputErrorWithConnect, { className: 'pr0 mt05', name: otherName })] })));
};
CategoryMiddleSingleFieldsAndLabel.propTypes = {
    disabled: propBool().isRequired,
    isEtcCheck: propBool().isRequired,
    middleId: propNumber().isRequired,
    middleIsOther: propBool().isRequired,
    middleName: propStr().isRequired,
    name: propStr().isRequired,
    otherMiddleClassName: propStr().isRequired,
    otherName: propStr().isRequired,
    wrapMiddleClassName: propStr().isRequired,
    wrapOnChange: propFunc().isRequired,
};
const enhance = onlyUpdateForKeys([
    'name',
    'otherName',
    'wrapMiddleClassName',
    'otherMiddleClassName',
    'middleId',
    'middleName',
    'middleIsOther',
    'disabled',
    'wrapOnChange',
    'isEtcCheck',
]);
export default enhance(CategoryMiddleSingleFieldsAndLabel);
